import { ToggleLayer } from 'react-laag';
import OutsideClickHandler from 'react-outside-click-handler';

import { DatePicker, withDateResolver } from 'components/shared/DatePicker';

import s from './index.module.css';
import { IWithDatePickerProps } from './types';

const ResolvedDatePicker = withDateResolver(DatePicker);

const WithDatePicker = ({
  children,
  value,
  isDisabled,
  onChange,
  position = 'BOTTOM_CENTER',
  possiblePositions = [],
}: IWithDatePickerProps) => {
  const selectedValue = typeof value === 'string' ? value : value?.start;

  return (
    <ToggleLayer
      fixed
      placement={{
        anchor: position,
        autoAdjust: true,
        triggerOffset: 14,
        possibleAnchors: possiblePositions,
      }}
      renderLayer={({ isOpen, layerProps, close }) => {
        return (
          isOpen && (
            <div style={{ ...layerProps.style, zIndex: 1300 }} ref={layerProps.ref} className={s['datepicker-wrapper']}>
              <OutsideClickHandler onOutsideClick={close}>
                <ResolvedDatePicker
                  mode="single"
                  selected={selectedValue}
                  onSelect={(val) => {
                    if (!val) {
                      close();
                    } else {
                      onChange({ start: val, end: val });
                    }
                  }}
                />
              </OutsideClickHandler>
            </div>
          )
        );
      }}
    >
      {({ triggerRef, toggle }) => (
        <div ref={triggerRef} onClick={(!isDisabled && toggle) || (() => {})}>
          {children}
        </div>
      )}
    </ToggleLayer>
  );
};
export default WithDatePicker;
